import { CLASS_LIST_WRAPPER } from './recombeeElementSelectors';

interface RecombeePlaceNewDomStructureProps {
  list: HTMLElement | null;
  newDom: HTMLElement;
  recommmIndex: number;
  replace: boolean;
}

export const recombeeAddDomStructure = ({
  list,
  newDom,
  recommmIndex,
  replace,
}: RecombeePlaceNewDomStructureProps) => {
  if (!list) return;

  if (replace) {
    // Přepsat články (používá se při prvním načtení)
    const replaceArticles: NodeListOf<HTMLDivElement> = list.querySelectorAll('.article-card');
    replaceArticles[recommmIndex].insertAdjacentElement('afterend', newDom);
    replaceArticles[recommmIndex].remove();
  } else {
    // Přidat nové články před tlačítko 'Načíst další články'
    const btnLoadMore: HTMLElement | null = list.querySelector(`.${CLASS_LIST_WRAPPER}`);
    if (btnLoadMore) btnLoadMore.insertAdjacentElement('beforebegin', newDom);
  }
};
